<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>
                            {{$router.currentRoute.meta.title}}
                            <router-link :to="{'name': $router.currentRoute.meta.options.cadastrarBotaoNome}" class="button big block-mobile float-right hidden-lg hidden-md" v-if="$root.user.tipo == 'admin'">
                                <i class="material-icons">add</i>
                                {{$router.currentRoute.meta.options.cadastrarBotaoTexto}}
                            </router-link>
                        </h3>
                    </div>

                    <!-- Row -->
                    <div class="row">

                        <!-- Dashboard Box -->
                        <div class="col-lg-12 margin-bottom-20 hidden-xl" v-if="$root.user.tipo == 'admin'">
                            <router-link :to="{'name': $router.currentRoute.meta.options.cadastrarBotaoNome}" class="button big block-mobile">
                                <i class="material-icons">add</i>
                                {{$router.currentRoute.meta.options.cadastrarBotaoTexto}}
                            </router-link>
                        </div>                          
                        <div class="col-xl-12">
                            <form method="get" style="width: 100%;" class="margin-bottom-0" v-on:submit.prevent="get">
                                <div class="row">
                                    <div class="col-lg-7 col-xs-12 col-xl-6 col-md-10">
                                        <div class="submit-field">
                                            <h5>Pesquisar:</h5>
                                            <input type="text" class="with-border margin-bottom-0" v-if="$router.currentRoute.name == 'UsuariosContratante'" placeholder="Nome, e-mail, telefone ou CPF.." name="pesquisa" v-model="form.pesquisa">
                                            <input type="text" class="with-border margin-bottom-0" v-if="$router.currentRoute.name == 'UsuariosGeral'" placeholder="Nome, e-mail, telefone.." name="pesquisa" v-model="form.pesquisa">
                                        </div>
                                    </div>

                                    <div class="col-lg-3 col-md-2">
                                        <div class="submit-field">
                                            <div class="hidden-xl hidden-lg hidden-sm margin-top-10"></div>
                                            <div class="hidden-xs clearfix" style="margin-top: 32px;"></div>
                                            <button class="button gray ">
                                                <i class="material-icons">search</i>
                                            </button>                                          
                                        </div>
                                    </div>
                                </div>
                                <div class="hidden-sm hidden-xl margin-top-20"></div>
                            </form> 

                            <div v-show="data.itens.length == 0 && loaded" class="job-overview empty">
                                <div class="job-overview-inner">
                                    <center>
                                        <i class="material-icons big">mood_bad</i>
                                        <p>Nenhum resultado encontrado.</p>
                                    </center>
                                </div>      
                            </div>

                            <div class="table-scroll" style="overflow-x: scroll;" v-show="data.itens.length > 0">

                                <table class="table table-bordered table-bordered-default table-responsive">
                                    <thead>
                                        <th style="min-width: 1px; width: 1px;">
                                            ID
                                        </th>
                                        <th style="min-width: 200px;">
                                            Nome
                                        </th>
                                        <th style="min-width: 90px; width: 90px;" v-if="$router.currentRoute.name == 'UsuariosGeral'">
                                            Tipo
                                        </th>                                        
                                        <th style="min-width: 200px; width: 200px;">
                                            Contato
                                        </th>
<!--                                         <th style="min-width: 112px">
                                            Telefone
                                        </th> -->
                                        <th v-if="$router.currentRoute.name == 'UsuariosContratante'">
                                            Pontos
                                        </th>  
                                        <th v-if="$router.currentRoute.name == 'UsuariosContratante'">
                                            CPF
                                        </th>          
<!--                                         <th style="min-width: 100px;" v-if="$router.currentRoute.name == 'UsuariosContratante'">
                                            Dispositivo
                                        </th> -->                                                                                                       
                                        <th>
                                            Cadastro
                                        </th>     
                                        <th style="min-width: 135px; width: 135px;" v-if="$root.user.tipo == 'admin'">
                                            Ações
                                        </th>                                                                     
                                    </thead>
                                    <tbody>   

                                        <tr v-for="item in data.itens" v-bind:class="{'desativado': item.ativo != 1}">
                                            <td data-label="ID">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.id}}
                                                </router-link>
                                            </td>
                                            <td data-label="Nome">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    <u>{{item.nome}}</u>
                                                </router-link>
                                            </td>
                                            <td data-label="Tipo" v-if="$router.currentRoute.name == 'UsuariosGeral'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{(item.tipo == 'admin' ? 'Administrador': '')}}
                                                    {{(item.tipo == 'prestador' ? 'Usuário de Filial': '')}}
                                                    {{(item.tipo == 'gerencial' ? 'Gerencial': '')}}
                                                </router-link>
                                            </td>                                             
                                            <td data-label="E-mail">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.email}}
                                                    <br>
                                                    <small><i class="material-icons">phone</i> {{item.telefone}}</small>

                                                </router-link>
                                            </td>                   
<!--                                             <td data-label="Telefone">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                </router-link>
                                            </td> -->
                                            <td data-label="Pontos" v-if="$router.currentRoute.name == 'UsuariosContratante'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.pontos}}
                                                </router-link>
                                            </td> 
                                            <td data-label="CPF" v-if="$router.currentRoute.name == 'UsuariosContratante'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.doc}}
                                                </router-link>
                                            </td>                                           
<!--                                             <td data-label="Dispositivo" v-if="$router.currentRoute.name == 'UsuariosContratante'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.dispositivo}}
                                                </router-link>
                                            </td>   -->                     
                                            <td data-label="Cadastro">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" v-bind:class="{'no-click': $root.user.tipo != 'admin'}">
                                                    {{item.datahora | formatDate}}
                                                </router-link>
                                            </td>   
                                            <td data-label="Ações" v-if="$root.user.tipo == 'admin'">
                                                <router-link :to="{'name': $router.currentRoute.meta.options.editarBotaoNome, 'query': {'c': item.cod}}" class="dashboard-status-button gray">Editar</router-link>
                                                <a class="dashboard-status-button color-red" v-on:click="del(item.cod)">Apagar</a>                                                                                      
                                                <a class="dashboard-status-button color-orange" v-on:click="bloquear(item.cod)" v-if="item.ativo == 1">Bloquear</a>                                                                                      
                                                <a class="dashboard-status-button color-orange" v-on:click="desbloquear(item.cod)" v-if="item.ativo == -1">Desbloquear</a>                                                                                      
                                            </td>                                                                                                                                       
                                        </tr>
                                       
<!--                                         <tr>
                                            <td data-label="ID">
                                                <a >
                                                    129
                                                </a>
                                            </td>
                                            <td data-label="Nome">
                                                <a >
                                                    <u>E-mail testes</u>
                                                </a>
                                            </td>
                                            <td data-label="E-mail">
                                                <a >
                                                    email@exemplo.com.br
                                                </a>
                                            </td>                   
                                            <td data-label="Telefone">
                                                <a >
                                                    47999999999
                                                </a>
                                            </td>
                                            <td data-label="CPF">
                                                <a >
                                                    09962639930
                                                </a>
                                            </td>                                           
                                            <td data-label="Dispositivo">
                                                <a >
                                                    Android
                                                </a>
                                            </td>                       
                                            <td data-label="Cadastro">
                                                <a >
                                                    07/07/2020 12:52
                                                </a>
                                            </td>                                                                                             
                                        </tr> -->

                                    </tbody>
                                </table>

                                <div class="pagination-container margin-top-60 margin-bottom-60">
                                    <nav class="pagination" v-show="$root.internet.online">
                                        <ul>
                                            <li class="pagination-arrow" v-show="data.page > 1" v-on:click="form.page = (data.page - 1); get(true);">
                                                <a>
                                                    <i class="material-icons">arrow_back</i>
                                                    Anterior
                                                </a>
                                            </li>
                                            <li class="pagination-arrow" v-show="data.page >= 1 && data.page < (data.pages.length)" v-on:click="form.page = (data.page + 1); get(true);">
                                                <a>
                                                    Próxima
                                                    <i class="material-icons">arrow_forward</i>
                                                </a>
                                            </li>    
                                            <br class="hidden-lg hidden-xl hidden-md">                                        
                                            <li v-for="(item, index) in data.pages" v-show="item.show">
                                                <a class="" v-bind:class="{'current-page': item.index == data.page}" v-on:click="form.page = item.index; get(true);">
                                                    {{item.index}}
                                                </a>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>                                
                            </div>
                        </div>                    
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'Usuarios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    filters: {
        formatDate: function(value) {
            if (!value) {
                return "";
                return false;
            }
            var d = value.split(" ");
            var date = d[0];
            var time = d[1];
            d = date.split("-");
            date = d[2] + "/" + d[1] + "/" + d[0];
            d = time.split(":");
            time = d[0] + ":" + d[1];

            // return formatDate(value.replace(" ", "T")) + " " + formatHours(value.replace(" ", "T"));
            return date + " " + time;
        }   
    },    
    data () {
        var self                    = this;
        return {
            "loaded":               false,
            "db":                   {
                "itens":            []
            },
            "data":                 {
                "itens":            []
            },
            "loading": {
                "submit":           false
            },
            "form": {
                "_cod":             self.$root.user.cod,
                "_token":           self.$root.user.token,
                "tipo":             self.$router.currentRoute.meta.options.tipo,
                "bloqueados":       true,
                "page":             1,
                "pesquisa":         ""
            }              
        }
    },
    methods: {
        getDB: function() {
            console.log("getDB()");
            var self = this;
            return new Promise(function(resolve, reject) {
                self.$root.db["usuarios"].query(function(doc) {
                    if (doc.request.all) {
                        emit(doc);
                    }
                }, {include_docs : true}).then(function (result) {
                    console.log("usuarios find()", "ok:", result);
                    if (result.rows.length > 0) {

                        var row = false;

                        result.rows.forEach(function(item) {
                            console.log("VALIDA", item);
                            if (item.doc.request.tipo == self.$router.currentRoute.meta.options.tipo) {
                                row = item;
                            }
                        })
                        if (row) {
                            console.log("Possui ROW", row);
                            self.db.itens     = row.doc.result.result.itens;
                        }
                        // self.db.itens     = result.rows[0].doc.result.result.itens;
                    } else {
                        self.db.itens     = [];
                    }
                    loading.hide();
                    self.$forceUpdate();

                    console.log("Setou usuarios:", self.db)
                    resolve(self.db.itens)

                }).catch(function (err) {
                    console.log("usuarios find()", "erro:", err);
                    resolve(err);
                });              
            });              
        },               
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                if (self.data.pesquisa != self.form.pesquisa) {
                    self.form.page  = 1;
                }
                if (self.form.pesquisa && !self.$root.internet.online) {

                    console.log("Esta pesquisando offline")

                    var clean = function(val) {
                        return (val ? val : "").toLowerCase().replace(/[^a-zA-Z0-9]/g, "").trim();
                    }

                    var itens = [];                        
                    var search= clean(self.form.pesquisa);

                    self.db.itens.forEach(function(item) {
                        if (clean(item.nome).indexOf(search) != -1 || clean(item.doc).indexOf(search) != -1 || clean(item.razaoSocial).indexOf(search) != -1) {
                            itens.push(item);
                        }
                    });
                    console.log("Resultado pesquisa itens", itens)
                    self.data.itens = itens;
                    loading.hide();
                    resolve(itens);

                } else {
                    axios.get("api/usuarios.php", {params: self.form, db: "usuarios"})
                    .then(response => {
                        
                        console.log("get() response", response);
                        self.data   = response.data.result; 
                        self.loaded = true;
                        loading.hide();
                        self.$root.scrollTop();
                        resolve(response.data.result);
      
                    })
                    .catch(error => {
                        console.log("get() error", error);                    
                        loading.hide();
                        reject(error);
                        alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    });   
                }

            });   
        }, 
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/usuarios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        bloquear: function(cod) {
            console.log("bloquear()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja bloquear esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.bloquear           = true;
                self.loading.del        = true;
                loading.show();
                
                axios.delete("api/usuarios.php", {params: form})
                .then(response => {
                    console.log("del() response", response)
                    self.loading.del    = false;
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    self.loading.del    = false;
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        desbloquear: function(cod) {
            console.log("desbloquear()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja desbloquear esse item?", function() {
                var form                = JSON.parse(JSON.stringify(self.form));
                form.cod                = cod;
                form.acao               = "desbloquear";
                self.loading.del        = true;
                loading.show();
                
                axios.put("api/usuarios.php", form)
                .then(response => {
                    console.log("del() response", response)
                   
                    self.get();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                   
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },        
    },
    created: function() {
        var self = this;
        if (!self.$root.db) {
            self.$root.$on("initDB", function(data) {
                self.get();
                self.getDB();
            });
        } else {
            self.get();
            self.getDB();
        }              
    },
    mounted: function() {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .desativado {
        opacity: 0.7 !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/Usuarios.vue